@if (visible) {
  <div
    class="badge bg-gray-100 bg-gray-700 fw-normal">{{ item?.count | number }}
  </div>
}
